module.exports = __webpack_public_path__ + "img/xqtx-banner2.b72d90bd.png";